module.exports = __webpack_public_path__ + "img/37.2dc97af8.jpg";